module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAYAAAAehFoBAAAAAXNSR0IArs4c6QAAAKRJREFUWAnt1jEKwyAUxnENuUNoOjnmBoJH9gI9QTe3zB0DHTuKBKMFj2B4wt9Fn4h+/FyeUgwEELhVQLfXnHNrjHFptaQ55/wJIfxqpn9ga+2WUtpLPUkK2rJorb/GmKf3/pzrZgl7lM1XWT7aIWHzu4YVlok4CCCAAAIIIDCgAO1lj0+jveyhyp0IIIAAAgggMIQA7WWPb6K97KHKnQggIETgAinmVWBvLrcJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/change@2x.png
// module id = 246
// module chunks = 0